import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class JaneDoePrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Indivisible.Black_900, FONT.Indivisible.SemiBold_600, FONT.Indivisible.Regular_400];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/rrb1vpx.css';
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
